import { SET_PARAMS } from "../types";

export default function(obj) {
  return {
    ...obj,
    type: SET_PARAMS
  };
}
